// 登录模式
import { atom } from "jotai";
import { getLoginSet, getLoginUnifySet } from "../auth";

// 允许的登录方式
export const loginModeAtom = atom(getLoginSet);

// 统一身份认证配置
export const loginUnifySetAtom = atom(getLoginUnifySet);
